import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Tag(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 14 16">
      <path d="M0 1H7L14 8L7 15L0 8V1ZM3.5 3.5C2.9375 3.5 2.5 3.96875 2.5 4.5C2.5 5.0625 2.9375 5.5 3.5 5.5C4.03125 5.5 4.5 5.0625 4.5 4.5C4.5 3.96875 4.03125 3.5 3.5 3.5Z" />
    </IconSvg>
  );
}
